import React from 'react';

const FlagGa = props => (
  <svg viewBox="0 0 400 300" {...props}>
    <path fill="#3a75c4" d="M0 0h400v300H0z" />
    <path fill="#fcd116" d="M0 0h400v200H0z" />
    <path fill="#009e60" d="M0 0h400v100H0z" />
  </svg>
);

export default FlagGa;
